import { View, view } from "@spawn/core";
import {
	CoinShowerView,
	LineMarkerView,
	LinePingerView,
	LineStepperView,
	ParallelModules,
	WinCounterView,
	WinPartyView,
	WinPartyViewOptions,
	WinSignTextView,
	WinSignView,
	WinSoundView,
} from "@spawn/slot-machine";
import { NrgLineStepperModule } from "../modules/lineStepperModule";
import { LineWinView } from "./lineWinView";

@view
export class NrgWinPartyView extends WinPartyView {
	constructor(protected options?: WinPartyViewOptions) {
		super(options);
	}

	protected override init({
		winCounterView = new WinCounterView(),
		winSoundView = new WinSoundView(),
		winSignView = new WinSignView(),
		winSignTextView = new WinSignTextView(),
		coinShowerView = new CoinShowerView(),
		lineMarkerView = new LineMarkerView(),
		linePingerView = new LinePingerView(),
		lineStepperView = new LineStepperView(),
		lineWinView = new LineWinView(),
	}: WinPartyViewOptions = {}): void {
		this.partyService.addParallelModule(ParallelModules.LineStepper, this.lineStepperModule());

		this.winCounterView = winCounterView;
		this.winSoundView = winSoundView;
		this.winSignView = winSignView;
		this.winSignTextView = winSignTextView;
		this.coinShowerView = coinShowerView;

		this.lineMarkerView = lineMarkerView;
		this.linePingerView = linePingerView;
		this.lineStepperView = lineStepperView;
		this.lineWinView = lineWinView;

		this.addChild(
			this.winSoundView,
			this.winSignView,
			this.coinShowerView,
			this.winSignTextView,
			this.winCounterView,
			...this.createExtraViews()
		);
		this.winContainerView.addChild(this.linePingerView, this.lineStepperView, this.lineWinView, this.lineMarkerView);
	}

	// init() runs in the super constructor, so these hooks must not read instance fields.
	protected lineStepperModule(): typeof NrgLineStepperModule {
		return NrgLineStepperModule;
	}

	/** Views that the game adds on top of the win party views. */
	protected createExtraViews(): View[] {
		return [];
	}
}
